import React from 'react'

function Supercharge() {
   return (
      <section className="container-fluid section_primary_bg">
         <div className="container text-center mb-4 innovation_comman blockchain_innovation">
            <h2 className="tech_title section_heading_title mb-2">
               Supercharge Your Fantasy Game App with Next-Level Features
            </h2>
            <p className="sub_body">
               We craft fantasy game apps that deliver seamless experiences with
               powerful, engaging, and user-friendly features. Our advanced{' '}
               <br />
               development solutions ensure your users stay hooked with
               real-time updates, immersive interactions, and smooth navigation.
            </p>
         </div>

         <div className="container text-center">
            <div className="innovation_card_main blockchain_innovation_card_main industry_web_new">
               <div className="row g-4 industry-grid travel-tourism-wrap">
                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/gov-public/real-time-score.svg"
                              alt="Health Icon"
                           />
                        </div>
                        <h3 className="industry-subtitle fw-semibold">
                           Real-Time Score Updates
                        </h3>
                        <p className="industry-description">
                           Keep your players on the game through live score and instant
                           updates. Our system gives users up-to-date stats, schedules, and
                           results, bringing them real-time information on their favorite
                           matches and teams. Whatever it is about news, live betting updates,
                           or in-match highlights, they will never lose a moment.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/gov-public/AR.svg"
                              alt="Fintech Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Augmented Reality (AR)
                        </h4>
                        <p className="industry-description">
                           Level up gaming with rich AR experiences. Allow your users to engage
                           with the fantasy world in real-time, blurring digital and physical
                           worlds for an engaging and lively gameplay experience.
                        </p>
                     </div>
                  </div>
                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/gov-public/Social-media.svg"
                              alt="Logistics Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Social Media Integration
                        </h4>
                        <p className="industry-description">
                           Increase user interaction by facilitating easy social media
                           connections. Players can share their success, invite friends over,
                           and compete with their social network, making your game go viral.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/gov-public/push-notification.svg"
                              alt="Ecommerce Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">Push Notifications</h4>
                        <p className="industry-description">
                           Keep your users engaged with timely and personalized alerts. Notify
                           them about live match updates, fantasy points, game results, and
                           special offers, driving continuous interaction.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/gov-public/gps-integration.svg"
                              alt="Real Estate Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">GPS Integration</h4>
                        <p className="industry-description">
                           Enhance location-based gaming experiences with GPS-powered features.
                           Deliver geolocation-based challenges, rewards, or real-world
                           interactions that bring a unique dimension to your app.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/gov-public/big-data.svg"
                              alt="Gaming Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">Big Data Analytics</h4>
                        <p className="industry-description">
                           Leverage strong analytics to provide personalized recommendations,
                           personalized insights, and game predictions. Leverage data-driven
                           insights to improve user engagement and maximize in-app experiences.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/gov-public/live-streaming.svg"
                              alt="Media Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">Live Streaming</h4>
                        <p className="industry-description">
                           Integrate live streaming for uninterrupted access to matches and
                           events. Let your users view their favorite games in real-time within
                           the app, improving their overall experience.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/gov-public/communication.svg"
                              alt="Social Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Communication Tools
                        </h4>
                        <p className="industry-description">
                           Allow in-game chats, forums, and messaging functionality to promote
                           community interaction. Allow players to discuss strategies, exchange
                           tips, and have a social gaming experience.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/gov-public/Multi-platform.svg"
                              alt="Travel Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Multi-Platform Compatibility
                        </h4>
                        <p className="industry-description">
                           Users must experience uninterrupted gameplay on their diverse range
                           of devices which includes smartphones, tablets and desktop
                           computers. Users benefit from cross-platform synchronization because
                           it allows them to move between devices effortlessly without losing
                           their work progress. This feature promotes accessibility and
                           real-time engagement.
                        </p>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
   )
}

export default Supercharge
